<script>
export default {
  methods: {
    buttonClicked(name, url) {
      window.gtag('event', 'startTrialClicked', {
        event_category: 'link-click',
        event_label: '',
        value: name,
      })
      window.location.href = url
    },
    addToUrl(url, add) {
      url.searchParams.append(add)
    },
    getUrl(type, btn) {
      let urlString

      if (type === 'login') {
        urlString = 'https://go.clavo.app/login'
      } else {
        urlString = 'https://go.clavo.app/register'
      }
      let url = new URL(urlString)
      // console.log('ff', this.$route.query)

      for (const [key, value] of Object.entries(this.$route.query)) {
        // each 'entry' is a [key, value] tupple
        url.searchParams.append(key, value)
      }

      if (btn) {
        url.searchParams.append('btn', btn)
      }

      return url.href
    },
  },
}
</script>
